module.exports = __webpack_public_path__ + "static/img/son3_active.68fa866e.png";